<div class="container quote-form-container">
  <!-- Form para crear la cotización -->
  <form [formGroup]="quoteParametersService.entity" class="form">
    
    <!-- Alertas superiores -->
    <div *ngIf="quoteParametersService.entity.get('status')?.value === 'Aceptada'" class="alert-warning">
      * Esta cotización ya ha sido aceptada, si la modificas pueden cambiar los datos del arrendamiento al que pertenece.
    </div>

    <div *ngIf="quoteParametersService.formMethod === 'EDIT' && quoteParametersService.useProvisionalData && !quoteParametersService.entity.get('client')?.value" class="alert-info">
      * Esta cotización contiene datos provisionales. Puedes usar el toggle superior para cambiar a datos reales y seleccionar clientes/activos específicos.
    </div>

    <!-- TARJETA 1: Cliente y Activos -->
    <div class="form-card">
      <div class="card-header">
        <div class="main-title" style="margin: 0; width: 100%;">Información del Cliente y Activos</div>
      </div>

      <div class="card-grid two-cols">
        <!-- Campo Cliente -->
        <div class="field-wrapper">
          <div style="display:flex; justify-content:space-between; align-items:center; gap:.75rem; margin-bottom:.35rem;">
            <label for="client" style="margin:0;">
              <span class="p-error">*</span>Cliente:
            </label>
            <!-- ADR-0006: Broker no ve el toggle (siempre provisional). -->
            <span *ngIf="!quoteParametersService.isBroker" style="display:flex; align-items:center; gap:.4rem;">
              <span class="toggle-label">{{ quoteParametersService.useProvisionalData ? 'Provisional' : 'Real' }}</span>
              <p-inputSwitch
                [(ngModel)]="quoteParametersService.useProvisionalData"
                (onChange)="onDataModeChange($event)"
                [ngModelOptions]="{standalone: true}"
                inputId="clientModeToggle">
              </p-inputSwitch>
            </span>
          </div>
          <ng-container *ngIf="quoteParametersService.useProvisionalData; else clientDropdown">
            <input type="text" formControlName="provitionalClient" class="p-inputtext p-component" placeholder="Ingresa el cliente" />
            <ng-container *ngIf="quoteParametersService.entity.get('provitionalClient')?.invalid && (quoteParametersService.entity.get('provitionalClient')?.dirty || quoteParametersService.entity.get('provitionalClient')?.touched)">
              <small class="p-error" *ngIf="quoteParametersService.entity.get('provitionalClient')?.errors?.['required']">El cliente es obligatorio.</small>
            </ng-container>
          </ng-container>
          <ng-template #clientDropdown>
            <p-dropdown
              scrollHeight="150px"
              [options]="quoteParametersService.customers"
              optionLabel="label"
              optionValue="value"
              formControlName="client"
              [filter]="true"
              filterBy="label,rfc"
              (onFilter)="onClientFilter($event)"
              [emptyFilterMessage]="'Sin coincidencias'"
              [showClear]="true"
              placeholder="Selecciona un cliente">
              <ng-template pTemplate="selectedItem">
                <div class="flex align-items-center" *ngIf="e.value.client">
                  <div>{{quoteParametersService.getCustomerName(e.value.client)}}</div>
                </div>
              </ng-template>
              <ng-template let-client pTemplate="item">
                <div class="flex align-items-center">
                  <div>{{ client.label }}</div>
                </div>
              </ng-template>
            </p-dropdown>
            <ng-container *ngIf="e.get('client')?.invalid && (e.get('client')?.dirty || e.get('client')?.touched)">
              <small class="p-error" *ngIf="e.get('client')?.errors?.['required']">El cliente es obligatorio.</small>
            </ng-container>
          </ng-template>
        </div>

        <!-- Campo Activos -->
        <div class="field-wrapper">
          <div style="display:flex; justify-content:space-between; align-items:center; gap:.75rem; margin-bottom:.35rem;">
            <label for="assets" style="margin:0;">
              <span class="p-error">*</span>Activos:
            </label>
            <!-- Regla: con cliente provisional el activo SIEMPRE es provisional → toggle deshabilitado. -->
            <span *ngIf="!quoteParametersService.isBroker" style="display:flex; align-items:center; gap:.4rem;"
                  [title]="quoteParametersService.useProvisionalData ? 'Con un cliente provisional, el activo también es provisional.' : ''">
              <span class="toggle-label">{{ quoteParametersService.useProvisionalAsset ? 'Provisional' : 'Real' }}</span>
              <p-inputSwitch
                [(ngModel)]="quoteParametersService.useProvisionalAsset"
                (onChange)="onAssetModeChange($event)"
                [disabled]="quoteParametersService.useProvisionalData"
                [ngModelOptions]="{standalone: true}"
                inputId="assetModeToggle">
              </p-inputSwitch>
            </span>
          </div>
          <ng-container *ngIf="quoteParametersService.useProvisionalAsset; else multiSelectTemplate">
            <input type="text" pInputText formControlName="provitionalAsset" class="p-inputtext p-component" placeholder="Ingresa el activo"/>
            <ng-container *ngIf="quoteParametersService.entity.get('provitionalAsset')?.invalid && (quoteParametersService.entity.get('provitionalAsset')?.dirty || quoteParametersService.entity.get('provitionalAsset')?.touched)">
              <small class="p-error" *ngIf="quoteParametersService.entity.get('provitionalAsset')?.errors?.['required']">El activo es obligatorio.</small>
            </ng-container>
          </ng-container>

          <ng-template #multiSelectTemplate>
            <p-multiSelect 
                formControlName="assets"
                scrollHeight="150px"
                [options]="quoteParametersService.actives"
                optionLabel="label" 
                optionValue="value"
                [filter]="true" 
                filterBy="label" 
                [showClear]="true" 
                placeholder="Selecciona los activos"
                (onChange)="onAssetsChange($event)"
                class="assets-multiselect"
              >
              <ng-template pTemplate="selectedItems">
                <ng-container *ngIf="!quoteParametersService.entity.get('assets')?.value || quoteParametersService.entity.get('assets')?.value.length === 0">
                  Selecciona los activos
                </ng-container>
                <span class="selected-assets-text" *ngIf="quoteParametersService.entity.get('assets')?.value?.length > 0">
                  <ng-container *ngFor="let asset of quoteParametersService.entity.get('assets')?.value; let last = last">
                    {{quoteParametersService.getActiveName(asset)}}<ng-container *ngIf="!last">, </ng-container>
                  </ng-container>
                </span>
              </ng-template>
              <ng-template let-asset pTemplate="item">
                  <div class="asset-option-item">{{ asset.label }}</div>
              </ng-template>
            </p-multiSelect>
            <ng-container *ngIf="quoteParametersService.entity.get('assets')?.invalid && (quoteParametersService.entity.get('assets')?.dirty || quoteParametersService.entity.get('assets')?.touched)">
              <small class="p-error" *ngIf="quoteParametersService.entity.get('assets')?.errors?.['required']">El activo es obligatorio.</small>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- TARJETA 2: Configuración -->
    <div class="form-card">
      <div class="card-header">
        <div class="main-title" style="margin: 0; width: 100%;">Configuración</div>
      </div>

      <div class="card-grid three-cols">
        <!-- Plazo en meses -->
        <div class="field-wrapper">
          <label for="terms">
            <span class="p-error">*</span>Plazo en meses:
          </label>
          <p-multiSelect 
            formControlName="terms" 
            scrollHeight="150px" 
            [options]="quoteParametersService.termInMonths" 
            optionLabel="label"
            [style]="{'width': '100%', 'height': '45px'}"
            optionValue="value"
            optionDisabled="disabled"
            [filter]="true"
            filterBy="label"
            [showClear]="true" 
            placeholder="Selecciona un plazo"
            (onChange)="quoteParametersService.onTermsChange($event.value)">
            <ng-template pTemplate="selectedItems">
              <div class="flex align-items-center">
                <div *ngFor="let term of quoteParametersService.entity.get('terms')?.value; let last = last">
                  {{quoteParametersService.getTermInMonths(term)}}<span *ngIf="!last">, </span>
                </div>
              </div>
            </ng-template>
            <ng-template let-term pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ term.label }}</div>
              </div>
            </ng-template>
          </p-multiSelect>

          <ng-container *ngIf="quoteParametersService.entity.get('terms')?.invalid && (quoteParametersService.entity.get('terms')?.dirty || quoteParametersService.entity.get('terms')?.touched)">
            <small class="p-error" *ngIf="quoteParametersService.entity.get('terms')?.errors?.['required']">El plazo en meses es obligatorio.</small>
          </ng-container>
        </div>

        <!-- Tipo de arrendamiento -->
        <div class="field-wrapper">
          <label for="leaseType">
            <span class="p-error">*</span>Tipo de arrendamiento:
          </label>
          <div>
            <div class="p-inputtext p-component p-disabled" style="height: 45px; display: flex; align-items: center; background-color: #f8f9fa; color: #6c757d;">
              <span>Puro</span>
            </div>
            <small class="field-help">Puro por defecto</small>
          </div>
          <input type="hidden" formControlName="leaseType" value="Puro" />
        </div>

        <!-- Inicio del arrendamiento -->
        <div class="field-wrapper">
          <label for="paymentStart">
            <span class="p-error">*</span>Inicio del arrendamiento:
          </label>
          <div>
            <div class="p-inputtext p-component p-disabled" style="height: 45px; display: flex; align-items: center; background-color: #f8f9fa; color: #6c757d;">
              <span>{{ formatDisplayDate(quoteParametersService.entity.get('paymentStart')?.value) }}</span>
            </div>
            <small class="field-help">Fecha actual</small>
          </div>
          <input type="hidden" formControlName="paymentStart" />
        </div>
      </div>

      <!-- Campos dinámicos de residuales -->
      <div class="card-grid dynamic-residuary" *ngIf="quoteParametersService.termsArrayControls.length > 0" style="margin-top: 12px;">
        <div *ngFor="let termGroup of quoteParametersService.termsArrayControls; let i = index" class="field-wrapper">
          <label for="residuary-{{ i }}">
            <span class="p-error">*</span> Residual para {{ termGroup.get('term')?.value }} meses:
          </label>
          <p-inputNumber
            [formControl]="getFormControl(termGroup, 'residuary')"
            inputId="residuary-{{ i }}"
            suffix=" %"
            mode="decimal"
            [minFractionDigits]="1"
            [maxFractionDigits]="2"
            locale="en-US"
            [min]="role === UserRole.BROKER ? 5 : 0"
            [max]="role === UserRole.BROKER ? 30 : 100"
            placeholder="Ingresa el residual"
          ></p-inputNumber>
          <ng-container *ngIf="termGroup.get('residuary')?.invalid && (termGroup.get('residuary')?.dirty || termGroup.get('residuary')?.touched)">
            <small class="p-error" *ngIf="termGroup.get('residuary')?.errors?.['required']">
              El residual para el término {{ termGroup.get('term')?.value }} es obligatorio.
            </small>
            <small class="p-error" *ngIf="termGroup.get('residuary')?.errors?.['min']">
              El valor mínimo es {{ termGroup.get('residuary')?.errors?.['min']['min'] }}.
            </small>
            <small class="p-error" *ngIf="termGroup.get('residuary')?.errors?.['max']">
              El valor máximo es {{ termGroup.get('residuary')?.errors?.['max']['max'] }}%.
            </small>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- TARJETA 3: Parametrización -->
    <div class="form-card">
      <div class="card-header">
        <div class="main-title" style="margin: 0; width: 100%;">Parametrización</div>
      </div>

      <div class="card-grid auto-fit">
        <!-- Valor total: computado (activo real) vs capturado (activo provisional) -->
        <div class="field-wrapper" *ngIf="!quoteParametersService.useProvisionalAsset">
          <label>Valor total:</label>
          <div class="assets-amount">
            {{ e.get('provitionalValue')?.value | currency }}
          </div>
        </div>

        <div class="field-wrapper" *ngIf="quoteParametersService.useProvisionalAsset">
          <label for="provitionalValue">
            <span class="p-error">*</span>Valor total:
          </label>
          <p-inputNumber 
            formControlName="provitionalValue"
            inputId="provitionalValue" 
            mode="currency" 
            currency="MXN" 
            locale="es-MX">
          </p-inputNumber>
          <ng-container *ngIf="e.get('provitionalValue')?.invalid && (e.get('provitionalValue')?.dirty || e.get('provitionalValue')?.touched)">
            <small class="p-error" *ngIf="e.get('provitionalValue')?.errors?.['required']">El valor total es obligatorio.</small>
            <small class="p-error" *ngIf="e.get('provitionalValue')?.errors?.['min']">El valor mínimo es {{ e.get('provitionalValue')?.errors?.['min']['min'] }}.</small>
          </ng-container>
        </div>

        <!-- Anticipo -->
        <div class="field-wrapper">
          <label for="advance">
            <span class="p-error">*</span>Anticipo:
          </label>
          <p-inputNumber formControlName="advance" inputId="advance" suffix=" %" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="2" locale="en-US" [min]="role === UserRole.BROKER ? 5 : 0"></p-inputNumber>
          <ng-container *ngIf="e.get('advance')?.invalid && (e.get('advance')?.dirty || e.get('advance')?.touched)">
            <small class="p-error" *ngIf="e.get('advance')?.errors?.['required']">El anticipo es obligatorio.</small>
            <small class="p-error" *ngIf="e.get('advance')?.errors?.['min']">El valor mínimo es {{ e.get('advance')?.errors?.['min']['min'] }}%.</small>
          </ng-container>
        </div>

        <!-- Tasa de interés -->
        <div class="field-wrapper" *ngIf="role !== UserRole.BROKER">
          <label for="interestRate">
            <span class="p-error">*</span>Tasa de interés:
          </label>
          <p-inputNumber formControlName="interestRate" inputId="interestRate" suffix=" %" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="2" locale="en-US" [min]="0" [max]="100"></p-inputNumber>
          <ng-container
            *ngIf="e.get('interestRate')?.invalid && (e.get('interestRate')?.dirty || e.get('interestRate')?.touched)">
            <small class="p-error" *ngIf="e.get('interestRate')?.errors?.['required']">La tasa de interés es obligatoria.</small>
            <small class="p-error" *ngIf="e.get('interestRate')?.errors?.['min']">El valor mínimo es {{e.get('interestRate')?.errors?.['min']['min']}}.</small>
          </ng-container>
        </div>

        <!-- Comisión por apertura -->
        <div class="field-wrapper">
          <label for="openingCommission">
            <span class="p-error">*</span>Comisión por apertura:
          </label>
          <p-inputNumber formControlName="openingCommission" inputId="openingCommission" suffix=" %" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="2" locale="en-US" [min]="role === UserRole.BROKER ? 3 : 0"></p-inputNumber>
          <ng-container
            *ngIf="e.get('openingCommission')?.invalid && (e.get('openingCommission')?.dirty || e.get('openingCommission')?.touched)">
            <small class="p-error" *ngIf="e.get('openingCommission')?.errors?.['required']">La comisión por apertura es obligatoria.</small>
            <small class="p-error" *ngIf="e.get('openingCommission')?.errors?.['min']">El valor mínimo es {{e.get('openingCommission')?.errors?.['min']['min']}}.</small>
          </ng-container>
        </div>

        <!-- Rentas anticipadas -->
        <div class="field-wrapper">
          <label for="advancedRents">
            <span class="p-error">*</span>Rentas anticipadas:
          </label>
          <p-inputNumber formControlName="advancedRents" inputId="advancedRents" [min]="0" [max]="100"></p-inputNumber>
          <ng-container
            *ngIf="e.get('advancedRents')?.invalid && (e.get('advancedRents')?.dirty || e.get('advancedRents')?.touched)">
            <small class="p-error" *ngIf="e.get('advancedRents')?.errors?.['required']">Las rentas anticipadas son obligatorias.</small>
            <small class="p-error" *ngIf="e.get('advancedRents')?.errors?.['min']">El valor mínimo es {{e.get('advancedRents')?.errors?.['min']['min']}}.</small>
          </ng-container>
        </div>

        <!-- Gastos de ratificación -->
        <div class="field-wrapper">
          <label for="ratificationExpenses">
            <span class="p-error">*</span>Gastos de ratificación:
          </label>
          <p-inputNumber formControlName="ratificationExpenses" inputId="ratificationExpenses" mode="currency" currency="MXN" locale="es-MX" [min]="0"></p-inputNumber>
          <ng-container
            *ngIf="e.get('ratificationExpenses')?.invalid && (e.get('ratificationExpenses')?.dirty || e.get('ratificationExpenses')?.touched)">
            <small class="p-error" *ngIf="e.get('ratificationExpenses')?.errors?.['required']">Los gastos de ratificación son obligatorios.</small>
            <small class="p-error" *ngIf="e.get('ratificationExpenses')?.errors?.['min']">El valor mínimo es {{e.get('ratificationExpenses')?.errors?.['min']['min']}}.</small>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- TARJETA 4: Accesorios -->
    <div class="form-card accessories-section">
      <div class="card-header">
        <div class="main-title" style="margin: 0; width: 100%;">Accesorios</div>
      </div>

      <div formArrayName="accessories">
        <div *ngFor="let accessory of accessories.controls; let i = index" [formGroupName]="i" class="accessory-item">
          <div class="remove-accessory">
            <p-button
              [style]="{'width': '20px', 'height': '25px'}"
              [rounded]="true"
              [text]="true"
              severity="danger"
              icon="pi pi-times" 
              size="small"
              styleClass="p-button p-button-danger"
              (click)="removeAccessory(i)">
            </p-button>
          </div>

          <div class="card-grid auto-fit">
            <!-- Nombre del Accesorio -->
            <div class="field-wrapper">
              <label for="name">
                <span class="p-error">*</span>Nombre del Accesorio:
              </label>
              <input type="text" formControlName="name" class="p-inputtext p-component" id="name"
                placeholder="Ingrese el nombre del accesorio" />
              <ng-container
                *ngIf="accessory.get('name')?.invalid && (accessory.get('name')?.dirty || accessory.get('name')?.touched)">
                <small class="p-error" *ngIf="accessory.get('name')?.errors?.['required']">El nombre es obligatorio.</small>
              </ng-container>
            </div>

            <!-- Tipo de Pago -->
            <div class="field-wrapper">
              <label for="paymentType">
                <span class="p-error">*</span>Tipo de Pago:
              </label>
              <p-dropdown formControlName="paymentType" [options]="paymentTypes" optionLabel="label" optionValue="value"
                placeholder="Selecciona el tipo de pago">
                <ng-template pTemplate="selectedItem">
                  <div class="flex align-items-center" *ngIf="accessory.get('paymentType')?.value">
                    <div>{{getPaymentType(accessory.get('paymentType')?.value)}}</div>
                  </div>
                </ng-template>
                <ng-template let-paymentType pTemplate="item">
                  <div class="flex align-items-center">
                    <div>{{ paymentType.label }}</div>
                  </div>
                </ng-template>
              </p-dropdown>
              <ng-container
                *ngIf="accessory.get('paymentType')?.invalid && (accessory.get('paymentType')?.dirty || accessory.get('paymentType')?.touched)">
                <small class="p-error" *ngIf="accessory.get('paymentType')?.errors?.['required']">El tipo de pago es obligatorio.</small>
              </ng-container>
            </div>

            <!-- Tasa de Interés -->
            <div class="field-wrapper" *ngIf="accessory.get('paymentType')?.value === 'financed'">
              <label for="interestRate">
                <span class="p-error">*</span>Tasa de Interés (%):
              </label>
              <p-inputNumber formControlName="interestRate" inputId="interestRate" suffix=" %" mode="decimal" [minFractionDigits]="1" [maxFractionDigits]="2" locale="en-US" [min]="0" [max]="100"></p-inputNumber>
              <ng-container
                *ngIf="accessory.get('interestRate')?.invalid && (accessory.get('interestRate')?.dirty || accessory.get('interestRate')?.touched)">
                <small class="p-error" *ngIf="accessory.get('interestRate')?.errors?.['required']">La tasa de interés es obligatoria.</small>
              </ng-container>
            </div>

            <!-- Subtotal -->
            <div class="field-wrapper">
              <label for="subtotal">
                <span class="p-error">*</span>Subtotal:
              </label>
              <p-inputNumber formControlName="amount" inputId="amount" mode="currency" currency="MXN" locale="es-MX" [minFractionDigits]="2" [maxFractionDigits]="2" [min]="0">
              </p-inputNumber>
              <ng-container
                *ngIf="accessory.get('amount')?.invalid && (accessory.get('amount')?.dirty || accessory.get('amount')?.touched)">
                <small class="p-error" *ngIf="accessory.get('amount')?.errors?.['required']">El subtotal es obligatorio.</small>
              </ng-container>
            </div>
          </div>

          <!-- Checkbox para indicar si es un seguro -->
          <div class="field-wrapper" style="margin-top: 1rem;">
            <label>
              <input type="checkbox" formControlName="isInsurance" (change)="toggleInsuranceDetails(i)" />
              Es un seguro
            </label>
          </div>

          <!-- Información del Seguro (Opcional) -->
          <div class="insurance-details" *ngIf="accessory.get('isInsurance')?.value">
            <div class="insurance-header">
              <span>Detalles del Seguro</span>
            </div>

            <div formGroupName="insuranceDetails" class="card-grid auto-fit">
              <ng-container *ngIf="accessory.get('insuranceDetails') as insuranceDetails">
                <!-- Fecha de inicio -->
                <div class="field-wrapper">
                  <label for="startPeriod">
                    <span class="p-error">*</span>Fecha de inicio:
                  </label>
                  <input type="date" formControlName="startPeriod" class="p-inputtext p-component" id="startPeriod" />
                  <ng-container
                    *ngIf="accessory.get('startPeriod')?.invalid && (accessory.get('startPeriod')?.dirty || accessory.get('startPeriod')?.touched)">
                    <small class="p-error" *ngIf="accessory.get('startPeriod')?.errors?.['required']">La fecha de inicio es obligatoria.</small>
                  </ng-container>
                </div>

                <!-- Fecha de vencimiento -->
                <div class="field-wrapper">
                  <label for="endPeriod">
                    <span class="p-error">*</span>Fecha de vencimiento:
                  </label>
                  <input type="date" formControlName="endPeriod" class="p-inputtext p-component" id="endPeriod" />
                  <ng-container
                    *ngIf="accessory.get('endPeriod')?.invalid && (accessory.get('endPeriod')?.dirty || accessory.get('endPeriod')?.touched)">
                    <small class="p-error" *ngIf="accessory.get('endPeriod')?.errors?.['required']">La fecha de vencimiento es obligatoria.</small>
                  </ng-container>
                </div>

                <!-- Proveedor -->
                <div class="field-wrapper">
                  <label for="provider">
                    <span class="p-error">*</span>Proveedor:
                  </label>
                  <p-dropdown formControlName="provider" [options]="providers" optionLabel="label" optionValue="value"
                    placeholder="Selecciona el proveedor">
                    <ng-template pTemplate="selectedItem">
                      <div class="flex align-items-center" *ngIf="insuranceDetails.get('provider')?.value">
                        <div>{{ getProviderName(insuranceDetails.get('provider')?.value) }}</div>
                      </div>
                    </ng-template>
                    <ng-template let-provider pTemplate="item">
                      <div class="flex align-items-center">
                        <div>{{ provider.label }}</div>
                      </div>
                    </ng-template>
                  </p-dropdown>
                  <ng-container
                    *ngIf="insuranceDetails.get('provider')?.invalid && (insuranceDetails.get('provider')?.dirty || insuranceDetails.get('provider')?.touched)">
                    <small class="p-error" *ngIf="insuranceDetails.get('provider')?.errors?.['required']">El proveedor es obligatorio.</small>
                  </ng-container>
                </div>

                <!-- Número de póliza -->
                <div class="field-wrapper">
                  <label for="policyNumber">
                    Número de póliza:
                  </label>
                  <input type="text" formControlName="policyNumber" class="p-inputtext p-component" id="policyNumber"
                    placeholder="Ingrese el número de póliza" />
                </div>

                <!-- Tipo de renovación -->
                <div class="field-wrapper">
                  <label for="renewalType">
                    <span class="p-error">*</span>Tipo de renovación:
                  </label>
                  <p-dropdown formControlName="renewalType" [options]="renewalTypes" optionLabel="label"
                    optionValue="value" placeholder="Selecciona el tipo de renovación">
                    <ng-template pTemplate="selectedItem">
                      <div class="flex align-items-center" *ngIf="accessory.get('insuranceDetails')?.get('renewalType')?.value">
                        <div>{{ getRenewalType(accessory.get('insuranceDetails')?.get('renewalType')?.value) }}</div>
                      </div>
                    </ng-template>
                    <ng-template let-renewalType pTemplate="item">
                      <div class="flex align-items-center">
                        <div>{{ renewalType.label }}</div>
                      </div>
                    </ng-template>
                  </p-dropdown>
                  <ng-container
                    *ngIf="accessory.get('renewalType')?.invalid && (accessory.get('renewalType')?.dirty || accessory.get('renewalType')?.touched)">
                    <small class="p-error" *ngIf="accessory.get('renewalType')?.errors?.['required']">
                      El tipo de renovación es obligatorio.
                    </small>
                  </ng-container>
                </div>

                <!-- Días antes del vencimiento para notificar -->
                <div class="field-wrapper">
                  <label for="notifyBeforeExpiry">
                    <span class="p-error">*</span>Aviso de vencimiento (días):
                  </label>
                  <p-inputNumber formControlName="notifyBeforeExpiry" inputId="notifyBeforeExpiry" [min]="0" [max]="30"></p-inputNumber>
                  <ng-container
                    *ngIf="accessory.get('notifyBeforeExpiry')?.invalid && (accessory.get('notifyBeforeExpiry')?.dirty || accessory.get('notifyBeforeExpiry')?.touched)">
                    <small class="p-error"
                      *ngIf="accessory.get('notifyBeforeExpiry')?.errors?.['required']">El
                      número de días es obligatorio.</small>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- Botón de Agregar Accesorio -->
      <div class="add-accessory">
        <button type="button" (click)="addAccessory()" class="p-button p-button-success">
          <i class="pi pi-plus"></i>
          <span>Agregar Accesorio</span>
        </button>
      </div>
    </div>
  </form>

  <!-- Visualización de los montos -->
  <div class="amounts-container">
    <div class="carrousel">
      <p-carousel
        [value]="quoteAmounts"
        [numVisible]="1"
        [numScroll]="1"
        [circular]="false"
      >
        <ng-template let-quote pTemplate="item">
          <div class="amounts">
            <div class="amounts-header">
              <span class="term-info">Plazo: {{quote.term}} meses</span>
              <span class="term-info">TIR: {{quote.irr | number:'1.2-2'}}%</span>
            </div>

            <div class="amounts-section">
              <div class="main-title" style="margin-bottom: 12px; width: 100%; font-size: small; padding-bottom: 9px;">Pago Inicial</div>
              <div class="amount-line">
                <span class="amount-label">Enganche:</span>
                <span class="amount-value">${{ quote.advance | number:'1.2-2' }}</span>
              </div>
              <div class="amount-line">
                <span class="amount-label">Comisión por apertura:</span>
                <span class="amount-value">${{ quote.openingCommission | number:'1.2-2' }}</span>
              </div>
              <div class="amount-line">
                <span class="amount-label">Rentas anticipadas:</span>
                <span class="amount-value">${{ quote.advancedRents | number:'1.2-2' }}</span>
              </div>
              <!-- F-016: mensualidad de los accesorios financiados de las rentas anticipadas (0 en cotizaciones viejas) -->
              <div class="amount-line" *ngIf="quote.advancedRentsAccessories > 0">
                <span class="amount-label">Accesorios de rentas anticipadas:</span>
                <span class="amount-value">${{ quote.advancedRentsAccessories | number:'1.2-2' }}</span>
              </div>
              <div class="amount-line">
                <span class="amount-label">Gastos de Ratificación:</span>
                <span class="amount-value">${{ quote.ratificationExpenses | number:'1.2-2' }}</span>
              </div>
              <div class="amount-line" *ngIf="quote.accessories > 0">
                <span class="amount-label">Accesorios:</span>
                <span class="amount-value">${{ quote.accessories | number:'1.2-2' }}</span>
              </div>

              <div class="section-divider"></div>
              <div class="amount-line">
                <span class="amount-label">Subtotal:</span>
                <span class="amount-value">${{ quote.advanceSubtotal | number:'1.2-2' }}</span>
              </div>
              <div class="amount-line">
                <span class="amount-label">IVA:</span>
                <span class="amount-value">${{ quote.advanceIva | number:'1.2-2' }}</span>
              </div>
              <div class="amount-line">
                <span class="amount-label">Total:</span>
                <span class="amount-value">${{ quote.advanceTotal | number:'1.2-2' }}</span>
              </div>
            </div>

            <div class="amounts-section">
              <div class="main-title" style="margin-bottom: 12px; width: 100%; font-size: small; padding-bottom: 9px;">Renta Mensual</div>
              <div class="amount-line">
                <span class="amount-label">Renta:</span>
                <span class="amount-value">${{ quote.monthlyAmount | number:'1.2-2' }}</span>
              </div>
              <div class="amount-line" *ngIf="quote.monthlyAccessories > 0">
                <span class="amount-label">Accesorios:</span>
                <span class="amount-value">${{ quote.monthlyAccessories | number:'1.2-2' }}</span>
              </div>
              <div class="amount-line">
                <span class="amount-label">IVA:</span>
                <span class="amount-value">${{ quote.monthlyIva | number:'1.2-2' }}</span>
              </div>
              <div class="amount-line">
                <span class="amount-label">Total:</span>
                <span class="amount-value">${{ quote.monthlyTotal | number:'1.2-2' }}</span>
              </div>
            </div>

            <div class="amounts-section">
              <div class="main-title" style="margin-bottom: 12px; width: 100%; font-size: small; padding-bottom: 9px;">Residual</div>
              <div class="amount-line">
                <span class="amount-label">Subtotal:</span>
                <span class="amount-value">${{ quote.residuary | number:'1.2-2' }}</span>
              </div>
              <div class="amount-line">
                <span class="amount-label">IVA:</span>
                <span class="amount-value">${{ quote.residuaryIva | number:'1.2-2' }}</span>
              </div>
              <div class="amount-line">
                <span class="amount-label">Total:</span>
                <span class="amount-value">${{ quote.residuaryTotal | number:'1.2-2' }}</span>
              </div>
            </div>
          </div>
        </ng-template>
      </p-carousel>
    </div>
  </div>
</div>

